import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";

defineComponent({
  tag: "oc-interactive-overlay-v2",
  extendOptions: { useOcAutoAriaLabel: true },
  styles: () => import("./InteractiveOverlayV2.global.scss?inline"),
  props: {},
  html: "<slot></slot><slot name='content'></slot>",
});
